export const ARI_SITE_URL = "https://hiari.com";
